<template>
  <div
    id="suit-container"
    class="suit-test-container"
  >
    <div class="suit-test-container--item">
      <Header/>
    </div>
    <div class="section-gray">
      <div
        v-if="!user.hasOwnProperty('suitabilityTestPoint')"
        class="suit-test-container--content"
      >
        <div class="section-white">
          <KulapPlusKycCard />
        </div>
      </div>
      <div v-else>
        <SummaryOfSuitTest
          :suitability-test-point="user.suitabilityTestPoint"
          :is-submit-knowledge-test="user.hasOwnProperty('knowledgeTestPoint')"
        />
      </div>
    </div>
    <div class="suit-test-container--item">
      <Footer/>
    </div>
  </div>
</template>

<script>
import Header from '@/features/Header'
import Footer from '@/components/Footer'
import SummaryOfSuitTest from '@/components/SummaryOfSuitTest'
import AcknowledgeRisk from '@/components/AcknowledgeRisk'
import { mapState } from 'vuex'
import cookie from '@/utils/cookie'
import Service from './service.js'
import { kulapApi, awsS3Api } from '@/resources'
import { showToastError } from '@/utils/helper'
import AmplitudeService from '@/services/amplitude'
import KulapPlusKycCard from '@/pages/KYC/components/kulapPlusKycCard'

export default {
  name: 'SuitabilityTest',
  components: {
    Header,
    Footer,
    SummaryOfSuitTest,
    AcknowledgeRisk,
    KulapPlusKycCard
  },
  data () {
    return {
      countries: [],
      form: [
        { Q: 'SUIT_TEST.Q_1.Q', A: [] },
        { Q: 'SUIT_TEST.Q_2.Q', A: [] },
        { Q: 'SUIT_TEST.Q_3.Q', A: [] },
        { Q: 'SUIT_TEST.Q_4.Q', A: [] },
        { Q: 'SUIT_TEST.Q_5.Q', A: [] },
        { Q: 'SUIT_TEST.Q_6.Q', A: [] },
        { Q: 'SUIT_TEST.Q_7.Q', A: [] },
        { Q: 'SUIT_TEST.Q_8.Q', A: [] },
        { Q: 'SUIT_TEST.Q_9.Q', A: [] },
        { Q: 'SUIT_TEST.Q_10.Q', A: [] },
        { Q: 'SUIT_TEST.Q_11.Q', A: [] },
        { Q: 'SUIT_TEST.Q_12.Q', A: [] },
        { Q: 'SUIT_TEST.Q_13.Q', A: [] },
        { Q: 'SUIT_TEST.Q_14.Q', A: [] }
      ],
      questionThreeOthersOptionInput: '',
      questionFiveOthersOptionInput: '',
      service: null,
      isLoadingSubmit: false,
      questionSixCountries: [],
      watchTracker: [],
      countryCount: 3,
      isAcceptAcknowledgeRisk: false,
      isActiveAcknowledgeRiskCheckbox: true
    }
  },
  computed: {
    ...mapState({
      user: state => state.user
    })
  },
  watch: {
    form: {
      handler: function (newVal) {
        if (this.watchTracker[5].A[0] && (this.form[5].A[0].text !== this.watchTracker[5].A[0].text)) {
          this.questionSixCountries = []
        }
        this.watchTracker = Object.assign([], JSON.parse(JSON.stringify(newVal)))
      },
      deep: true
    }
  },
  async created () {
    if (!cookie.get('user') || !cookie.get('accessToken')) {
      this.$router.push({ name: 'Login', query: { next: 'SuitabilityTest' } })
      return
    }
    this.service = new Service({
      store: this.$store,
      kulapApi,
      awsS3Api
    })
    const [user, countries] = await Promise.all([
      this.service.getUserProfile(),
      this.service.getCountries()
    ])
    this.countries = countries
    if (!user.isActive) {
      this.$router.push({ name: 'Exchange' })
    }
    this.watchTracker = Object.assign([], JSON.parse(JSON.stringify(this.form)))
    this.$scrollTo('#suit-container')
  },
  mounted () {
    this.$refs['acknowledge-risk-box'].addEventListener('scroll', this.catchScroll)
  },
  beforeDestroy () {
    this.$refs['acknowledge-risk-box'].removeEventListener('scroll', this.catchScroll)
  },
  methods: {
    async submit () {
      const validateFieldResult = await this.$validator.validate()
      if (!validateFieldResult) {
        const convertNameToId = Object.keys(this.errors.collect()).sort()[0].toLowerCase().replace(/ /g, '-').replace(/[()?.]/g, '')
        if (convertNameToId.includes('question-6-country')) {
          this.$scrollTo(`#question-6-country`)
        } else {
          this.$scrollTo(`#${convertNameToId}`)
        }
        return
      }
      try {
        if (this.form.find(q => q.Q === 'SUIT_TEST.Q_3.Q').A.find(f => f.text === 'SUIT_TEST.Q_3.A_5') && this.questionThreeOthersOptionInput) {
          this.form.find(q => q.Q === 'SUIT_TEST.Q_3.Q').A.find(f => f.text === 'SUIT_TEST.Q_3.A_5').others = this.questionThreeOthersOptionInput
        }
        if (this.form.find(q => q.Q === 'SUIT_TEST.Q_5.Q').A.find(f => f.text === 'SUIT_TEST.Q_5.A_7') && this.questionFiveOthersOptionInput) {
          this.form.find(q => q.Q === 'SUIT_TEST.Q_5.Q').A.find(f => f.text === 'SUIT_TEST.Q_5.A_7').others = this.questionFiveOthersOptionInput
        }
        this.setPointOfQuestionSix()
        this.isLoadingSubmit = true
        const mapData = {
          suitTestData: this.form,
          isAcceptAcknowledgeRisk: this.isAcceptAcknowledgeRisk
        }
        const reulst = await this.service.submitSuitTest(mapData)
        this.isLoadingSubmit = false
        this.trackQuestion('Submit suit-test success')
        if (reulst.success) {
          this.$buefy.toast.open({
            message: `Success !`,
            type: 'is-success'
          })
          await this.service.getUserProfile()
        } else {
          this.$buefy.toast.open({
            message: `Sorry, something went wrong.`,
            type: 'is-danger'
          })
        }
      } catch (e) {
        showToastError(e)
      }
    },
    setPointOfQuestionSix () {
      if (this.questionSixCountries) {
        let point = 0
        const highRiskCountries = this.questionSixCountries
          .map(val => {
            // set point for country type superBlackList and greyList
            const countryData = this.countries.find(c => c.en_short_name === val)
            if (countryData && countryData.hasOwnProperty('type')) {
              if (countryData.type === 'superBlackList') {
                return 10
              } else if (countryData.type === 'greyList') {
                return 7
              }
            }
            return 0
          })
          .filter(val => val > 0)
        const indexOfQuestionSix = this.form.findIndex(q => q.Q === 'SUIT_TEST.Q_6.Q')
        if (highRiskCountries.length) {
          point = Math.max(...highRiskCountries)
        } else {
          if (this.form[indexOfQuestionSix].A[0].text === 'SUIT_TEST.Q_6.A_1') {
            point = 1
          } else if (['SUIT_TEST.Q_6.A_2', 'SUIT_TEST.Q_6.A_4'].includes(this.form[indexOfQuestionSix].A[0].text)) {
            point = 3
          } else if (['SUIT_TEST.Q_6.A_3', 'SUIT_TEST.Q_6.A_5'].includes(this.form[indexOfQuestionSix].A[0].text)) {
            point = 5
          }
        }
        this.form[indexOfQuestionSix].A[0].point = point
        this.form[indexOfQuestionSix].A[0].countries = this.questionSixCountries
      }
    },
    catchScroll () {
      const minPercentageToActiveAccept = this.$refs['acknowledge-risk-box'].clientHeight * 1.05
      if (this.$refs['acknowledge-risk-box'].scrollHeight - this.$refs['acknowledge-risk-box'].scrollTop <= minPercentageToActiveAccept) {
        this.isActiveAcknowledgeRiskCheckbox = false
      }
    },
    trackQuestion (questionNumber) {
      AmplitudeService.inputQuestion('EVENT_SUIT_TEST', { questionNumber })
    },
    trackAcknowledgeRisk () {
      this.$nextTick(() => {
        AmplitudeService.inputQuestion('EVENT_SUIT_TEST',
          {
            isAcceptAcknowledgeRisk: this.isAcceptAcknowledgeRisk
          }
        )
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.q6-country {
  margin-top: 5px;
}
.number-picker {
  margin-left: 27px;
}
.others-input-box {
  margin-top: 10px;
  width: 40%;
  min-width: 300px;
}
.suit-test-container {
  float: left;
  width: 100%;
  min-height: 100vh;
  &--item {
    float: left;
    width: 100%;
  }
  &--content {
    max-width: 1024px;
    margin: 0 auto;
  }
}
.section-gray {
  float: left;
  width: 100%;
  padding-bottom: 80px;
}

.section-white {
  display: block;
  margin: 0 auto;
  padding: 50px;
  max-width: 1024px;
  width: calc(100% - 20px);
  border-radius: 3px;
  box-shadow: 0 0 6px -2px rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
}

.suit-test-title {
  margin: 35px 0;
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  color: #000000;
}
.section-white {
  display: block;
  margin: 0 auto;
  padding: 50px;
  max-width: 1024px;
  width: calc(100% - 20px);
  border-radius: 3px;
  box-shadow: 0 0 6px -2px rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
}
.question {
  font-family: Roboto;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0.3px;
  color: #000000;
}
.answers {
  margin-top: 20px;
  margin-left: 20px;
  margin-bottom: 30px;
  .answer {
    font-family: Roboto;
    font-size: 14px;
    color: #000000;
    margin-bottom: 20px;
  }
}
.is-accept-acknowledge {
  padding: 4px 0 0;
}
.scroll-box {
  overflow-y: scroll;
  height: 600px;
  border: #363636 solid 1px;
}
.submit-btn {
  display: flex;
  justify-content: center;
  width: 165px;
  height: 45px;
  border-radius: 3px;
  border: unset;
  box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.5);
  background-color: #2193ff;
  margin: 50px auto 0;
  font-family: Roboto;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0.37px;
  text-align: center;
  color: #ffffff;
  padding: 13px 0px;
}
.error-text-mg-left {
  margin-left: 27px;
}
.alert-message {
  padding-left: 0px;
  color: red;
}
//  For Desktop
@media screen and (min-width: 470px){
  .q6-country {
    width: 22%;
    min-width: 220px;
  }
}

@media screen and (max-width: 470px) {
  .country-w-100 {
    width: 100%
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/SuitabilityTest/index.vue